import { ProductType } from '../types/products';
import enviro from 'enviro';

export function getSourceId(
  productType: ProductType,
  productId: number | string
) {
  return [`${String(productType)}__${productId}`];
}

//These actions are for use in Provider analytics dashboard, not general product analytics

enum MARKETPLACE_CTA_ACTION {
  HEADER_CONNECT = 'header_connect',
  HEADER_RECONNECT = 'header_reconnect',
  SIDEBAR_SUPPORT = 'sidebar_support',
  SIDEBAR_SETUP_GUIDE = 'sidebar_setup_guide',
  SIDEBAR_FACEBOOK = 'sidebar_facebook',
  SIDEBAR_COMPANY = 'sidebar_company',
  SIDEBAR_LIVE_CHAT = 'sidebar_live_chat',
  SIDEBAR_EMAIL_SUPPORT = 'sidebar_email_support',
  MANAGE_APP_CLICK = 'manage_app',
  LOCATION = 'location',
  PRIMARY_CTA = 'primary_cta',
  COMPANY_WEBSITE = 'company_website',
}

type marketplaceCtaActionProps =
  | 'HEADER_CONNECT'
  | 'HEADER_RECONNECT'
  | 'SIDEBAR_SUPPORT'
  | 'SIDEBAR_SETUP_GUIDE'
  | 'SIDEBAR_FACEBOOK'
  | 'SIDEBAR_COMPANY'
  | 'SIDEBAR_LIVE_CHAT'
  | 'SIDEBAR_EMAIL_SUPPORT'
  | 'MANAGE_APP_CLICK'
  | 'LOCATION'
  | 'PRIMARY_CTA'
  | 'COMPANY_WEBSITE';

const isQa = () => enviro.isQa();

export const trackCustomMarketplaceOfferingBehavioralEvent = (
  action: marketplaceCtaActionProps
) => {
  const _hsq = (window as any)._hsq || [];
  _hsq.push([
    'trackCustomBehavioralEvent',
    {
      name: isQa()
        ? 'pe53_marketplace_offerings_cta_clicks_qa'
        : 'pe53_marketplace_offerings_cta_clicks',
      properties: {
        marketplace_cta_action: MARKETPLACE_CTA_ACTION[action],
      },
    },
  ]);
};
